<template>
  <div class="header-bar clearfix">
    <h1 class="fl">{{title}}</h1>
    <span class="header-bar__logout fr" @click="logout">退出</span>
    <p class="fr">
      欢迎您，
      <span v-if="user">{{user.username}}</span>
    </p>
    <template v-if="['agency', 'ka', 'ad-user'].includes(platform)">
      <p class="fr">id：{{balance.accountId}}</p>
    </template>
    <template
      v-if="['admin', 'finance', 'ka', 'ad-user'].indexOf(platform) === -1 && idTag.indexOf(parseInt(user.id_tag)) === -1"
    >
      <p class="fr">今日消费：{{balance.cost}}元</p>
      <p class="fr">余额：{{balance.balance}}元</p>
    </template>
    <template v-if="['ka', 'ad-user'].includes(platform)">
      <p class="fr">返货余额：{{balance.rebate}}元</p>
      <p class="fr">现金余额：{{balance.cash}}元</p>
      <p class="fr">总余额：{{balance.balance}}元</p>
    </template>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie';
import * as store from 'store';
import { PLATFORMS, COOKIE_USER, COOKIE_PWD, STORE_USER_ID } from '@/global/util/constants'
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'HeaderBar',
  data () {
    return {
      idTag: [8, 9, 10]
    }
  },
  props: {
    platform: {
      type: String,
      required: true,
      validate: val => PLATFORMS.indexOf(val) > -1
    },
    title: {
      type: String,
      required: true
    },
    balance: {
      type: Object,
      default: () => {
        return {
          cost: '',
          balance: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'login/user'
    })
  },
  methods: {
    ...mapMutations(['login/setMenuData']),
    ...mapActions(['login/logout']),
    logout () {
      const platform = this.platform;
      this['login/logout']({ platform }).then((data) => {
        if (data.code === 1) {
          Cookies.remove(`${platform}:${COOKIE_USER}`)
          Cookies.remove(`${platform}:${COOKIE_PWD}`)
          store.remove(`${platform}:${STORE_USER_ID}`)
          // this['login/setMenuData']([])
          this.$router.push('/login')
        }
      })
    }
  }
};
</script>

<style lang="scss">
@include b(header-bar) {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  min-width: 1366px;
  height: 45px;
  line-height: 45px;
  background: #020008;
  h1 {
    font-size: 22px;
    color: #fff;
    height: 22px;
    line-height: 22px;
    margin-left: 28px;
    margin-top: 11px;
  }
  p {
    margin-right: 30px;
    font-size: 16px;
    color: #becfe0;
    span {
      color: #fff;
    }
  }

  @include e(logout) {
    padding: 2px 10px;
    border-radius: 3px;
    color: #fff;
    line-height: 20px;
    margin-right: 70px;
    margin-top: 10px;
    cursor: pointer;
    background: #e21d25;
    border: 1px solid #e21d25;

    &:hover {
      background: #e21d25;
    }
  }
}
</style>
